import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { MatchDetail } from "@app/core/match/domain/model/match-detail";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { MatchDetailMapper } from "@app/core/match/data/network/match-detail.mapper";
import { MatchPaymentInfo } from "@app/core/match/domain/model/match-payment-info";
import { MatchPaymentInfoMapper } from "@app/core/match/data/network/match-payment-info.mapper";

/**
 * Web service used to get match detail.
 */
@Injectable({
  providedIn: "root",
})
export class MatchPaymentInfoWS {
  constructor(private handler: BaseHandler) {}

  execute(matchId: string, token: string): Observable<MatchPaymentInfo> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.PAYMENT_INFO_ENDPOINT(matchId))
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.handler
      .execute(parameters)
      .pipe(map((response) => MatchPaymentInfoMapper.deserialize(response)));
  }
}
